<template>
  <div class="sort-button">
    <div class="btn-group">
      <div
        class="btn"
        v-if="isShowDistance"
        @click="clickBtn(distance)"
        :class="index == 0 ? 'active' : ''"
      >
        <span style="margin-right: 6px">距离排序</span>
        <i :class="[distance ? 'el-icon-bottom' : 'el-icon-top']"></i>
      </div>
      <div
        class="btn1"
        @click="clickBtn1(update)"
        :class="index == 1 ? 'active' : ''"
      >
        <span style="margin-right: 5px">时间排序</span>
        <i :class="[update ? 'el-icon-bottom' : 'el-icon-top']"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sortBtn",
  props: {
    update: {
      type: Boolean,
      default: true
    },
    distance: {
      type: Boolean,
      default: true
    },
    /*是否显示距离排序  */
    isShowDistance:{
      type: Boolean,
      default: true
    },
    isTeam:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 1
    }
  },
  methods: {
    //距离排序按钮
    clickBtn(distance) {
      this.$parent.param.page=1;
      this.$parent.list=[];
      this.$parent.loadingTrue=true
      this.index = 0
      //2:按距离排序
      this.$parent.param.sortType = 2
      //1:距离降序 2:距离升序
      this.$parent.param.distanceSortType = distance ? 2 : 1
      this.$parent.getList()
      distance = !distance
      this.$parent.distance = distance
    },
    //时间排序按钮
    clickBtn1(update) {
      this.$parent.param.page=1;
      this.$parent.list=[];
      this.$parent.loadingTrue=true
      this.index = 1
      if(this.isShowDistance){//劳务、临时用工
        //1:按时间排序
        this.$parent.param.sortType = 1
        this.$parent.param.timeSortType = update ? 2 : 1
      }else{
        //1:时间降序 2:时间升序
        console.log(this.team);
        this.$parent.param.sortType = this.isTeam ?  (update ? '2' : '1') : (update ? 2 : 1)
      }
      //1:时间降序 2:时间升序
      this.$parent.getList()
      update = !update
      this.$parent.update = update
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-button {
  position: relative;
  width: 1200px;
  margin: 10px auto 0;
  box-sizing: border-box;
  height: 52px;
  line-height: 50px;
  background: #fafafa;
  border: 1px solid #e4e7ed;
  padding-left: 20px;
  .btn-group {
    display: flex;
    height: 50px;
    align-items: center;
    color: #969696;
    font-size: 14px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 110px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #e4e7ed;
      cursor: pointer;
      user-select: none;
    }
    .btn1 {
      width: 136px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      background: #ffffff;
      border: 1px solid #e4e7ed;
      cursor: pointer;
      user-select: none;
    }
    .active {
      border: 1px solid #e1251b;
      color: #e1251b;
    }
  }
}
</style>